import Button from "@material-tailwind/react/Button";
import H3 from "@material-tailwind/react/Heading3";
import Modal from "@material-tailwind/react/Modal";
import ModalBody from "@material-tailwind/react/ModalBody";
import ModalFooter from "@material-tailwind/react/ModalFooter";
import ModalHeader from "@material-tailwind/react/ModalHeader";
import emailjs from 'emailjs-com';
import React, { useRef } from 'react';
import Flip from 'react-reveal/Flip';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Contact = () => {
    const form = useRef();
    const [showModal, setShowModal] = React.useState(false);
    const notify = () => toast("Email Sent Successfully!");
    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm(process.env.REACT_APP_EMAILJS_SERVICE_ID, process.env.REACT_APP_EMAILJS_TEMPLATEID, form.current, process.env.REACT_APP_EMAILJS_USER_ID)
            .then((result) => {
                console.log(result.text);
                if (result.text === "OK") {
                    form.current.reset();
                    notify();
                }
            }, (error) => {
                console.log(error.text);
            });
    };
    return (
        <Flip left>
            <div id="contact" className="w-full min-h-screen p-4">
                <H3 color="lightBlue">Let's Talk</H3>
                <ToastContainer
                    position="top-center"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
                <form ref={form} onSubmit={sendEmail} className="flex flex-col lg:w-4/2 md:w-4/2 sm:w-10/12 mx-auto my-auto">
                    <input type="hidden" name="contact_number"></input>
                    <input className="my-2 rounded-md shadow-md p-4" placeholder="Enter Name" type="text" name="user_name"></input>
                    <input className="my-2 rounded-md shadow-md p-4" placeholder="Enter Email" type="email" name="user_email"></input>
                    <textarea className="my-2 rounded-md shadow-md p-4" placeholder="Enter Message" name="message" type="text"></textarea>
                    <input className="w-2/4 mx-auto px-4 py-2 uppercase text-xl bg-gradient-to-r from-blue-600 to-blue-500 text-white my-4 rounded-md shadow-md cursor-pointer"
                        type="submit" value="Send">
                    </input>
                    <Modal size="sm" active={showModal} toggler={() => setShowModal(false)}>
                        <ModalHeader toggler={() => setShowModal(false)}>
                            Success
                        </ModalHeader>
                        <ModalBody>
                            <p className="text-base leading-relaxed text-gray-600 font-normal">
                                Email Sent Successfully!
                            </p>
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                color="red"
                                buttonType="link"
                                onClick={(e) => setShowModal(false)}
                                ripple="dark"
                            >
                                Close
                            </Button>
                        </ModalFooter>
                    </Modal>
                </form>

            </div>
        </Flip>
    );
};

export default Contact;